







































import Vue, { PropType } from 'vue';
import { FlippableCardInfo } from '@/types';

export default Vue.extend({
	name: 'FlippableCard',

	props: {
		card: {
			type: Object as PropType<FlippableCardInfo>,
			default: null,
		},

		cardIndex: {
			type: Number,
			default: 0,
		},

		slideToSelectedCard: {
			type: Function as PropType<() => void>,
			default: null,
		},
	},
});
